export enum TrackingEnum {
  PENDING = "Pendiente",
  TRACKING = "Tracking",
}
